import createClient from '../../helpers/api-client';

import { clone } from '../../helpers';

const storeSuffix = 'Companies';

// Actions
export const FETCH_COMPANIES = `fetchCompaniesByQueryAction${storeSuffix}`;

export const SET_QUERY_ACTION = `setQueryAction${storeSuffix}`;
export const SET_TAKE_ACTION = `setTakeAction${storeSuffix}`;
export const SET_PAGE_ACTION = `setPageAction${storeSuffix}`;
export const SET_CATEGORY_ACTION = `setCompaniesCategoryAction${storeSuffix}`;
export const SET_REGION_ACTION = `setCompaniesRegionAction${storeSuffix}`;
// set rating action is commented as rating filter is hidden
// export const SET_RATING_ACTION = `setCompaniesRatingAction${storeSuffix}`;
export const SET_CERTIFICATE_ACTION = `setCompaniesCertificateAction${storeSuffix}`;

export const RESET_SEARCH_ACTION = `resetAction${storeSuffix}`;

// Mutations
export const BEGIN_FETCH_COMPANIES = `beginFetchCompaniesMutation${storeSuffix}`;
export const RECEIVED_COMPANIES = `receivedCompaniesMutation${storeSuffix}`;
export const COMPANIES_NOT_FOUND = `companiesNotFoundMutation${storeSuffix}`;

export const SET_QUERY = `setQueryMutation${storeSuffix}`;
export const SET_TAKE = `setTakeMutation${storeSuffix}`;
export const SET_PAGE = `setPageMutation${storeSuffix}`;
export const SET_CATEGORY = `setCompaniesCategoryMutation${storeSuffix}`;
export const SET_REGION = `setCompaniesRegionMutation${storeSuffix}`;
// set rating is commented as rating filter is hidden
// export const SET_RATING = `setCompaniesRatingMutation${storeSuffix}`;
export const SET_CERTIFICATE = `setCompaniesCertificateMutation${storeSuffix}`;

export const RESET_SEARCH = `resetSearchMutation${storeSuffix}`;

// Getters
export const GET_COMPANIES = `getCompaniesGetter${storeSuffix}`;
export const IS_LOADING = `getIsLoadingGetter${storeSuffix}`;
export const GET_ERROR = `getErrorGetter${storeSuffix}`;

export const GET_SEARCH_PARAMS = `getSearchParamsGetter${storeSuffix}`;
export const GET_PAGE = `getPageGetters${storeSuffix}`;
export const GET_FACET_TITLE = `getFacetTitel${storeSuffix}`;
export const GET_FACET_CONTENT = `getFacetContent${storeSuffix}`;
export const GET_FACET_FULL_CONTENT = `getFacetFullContent${storeSuffix}`;

export const GET_CATEGORY = `getCategory${storeSuffix}`;
export const GET_REGION = `getRegion${storeSuffix}`;

export const modelState = () => ({
    companies: {
        isLoading: true,
        error: false,
        searchParams: {
            q: '',
            page: 1,
            take: 10,
            category: null,
            region: null,
            // to not send rating to request as rating filter is hidden
            // rating: null,
            certid: null,
        },
        data: [],
    },
});

export const actions = {
    [FETCH_COMPANIES]: ({ state, commit }) => {

        return new Promise(async (resolve, reject) => {
            const apiClient = createClient(state);

            commit(BEGIN_FETCH_COMPANIES);

            try {
                const payload = clone(state.companies.searchParams);

                payload.regionid = payload.region ? payload.region.Id : null;
                payload.categoryid = payload.category ? payload.category.Id : null;

                delete payload.region;
                delete payload.category;

                const res = await apiClient.get(`/api/companies`, {
                    params: payload,
                });
                commit(RECEIVED_COMPANIES, res);

                resolve(res);
            } catch (error) {
                commit(COMPANIES_NOT_FOUND, {
                    error,
                });
                resolve(error);
            }
        });
    },
    [SET_QUERY_ACTION]: ({ state, commit }, query) => {
        commit(SET_QUERY, query);
    },
    [SET_TAKE_ACTION]: ({ state, commit }, take) => {
        commit(SET_TAKE, take);
    },
    [SET_PAGE_ACTION]: ({ state, commit, dispatch }, page) => {
        commit(SET_PAGE, page);
    },
    [SET_CATEGORY_ACTION]: ({ state, commit }, category) => {
        if(category == null && category != state.companies.searchParams.category){
            commit(SET_CATEGORY, null);
        }

        if(state.companies.searchParams.category && state.companies.searchParams.category.Id == category.Id) return;

        commit(SET_CATEGORY, category);
    },
    [SET_REGION_ACTION]: ({ state, commit }, region) => {
        if(region == null && region != state.companies.searchParams.region){
            commit(SET_REGION, null);
        }
        if(state.companies.searchParams.region && state.companies.searchParams.region.Id == region.Id) return;

        commit(SET_REGION, region);
    },
    [SET_CERTIFICATE_ACTION]: ({ state, commit }, certid) => {
        commit(SET_CERTIFICATE, certid);
    },
    [RESET_SEARCH_ACTION]: ({ state, commit }) => {
        commit(RESET_SEARCH);
    }
};

export const mutations = {
    [BEGIN_FETCH_COMPANIES]: state => {
        state.companies.isLoading = true;
        state.companies.error = false;
    },
    [RECEIVED_COMPANIES]: (state, payload) => {
        const { data } = payload;
        state.companies.isLoading = false;
        state.companies.error = false;
        state.companies.data = data;
    },
    [COMPANIES_NOT_FOUND]: (state, payload) => {
        state.companies.isLoading = false;
        state.companies.error = true;
    },
    [SET_QUERY]: (state, query) => {
        state.companies.searchParams.q = query;
        state.companies.searchParams.page = 1;
    },
    [SET_TAKE]: (state, take) => {
        state.companies.searchParams.take = take;
        state.companies.searchParams.page = 1;
    },
    [SET_PAGE]: (state, page) => {
        state.companies.searchParams.page = page;
    },
    [SET_CATEGORY]: (state, category) => {
        state.companies.searchParams.category = category;
        state.companies.searchParams.page = 1;
    },
    [SET_REGION]: (state, region) => {
        state.companies.searchParams.region = region;
        state.companies.searchParams.page = 1;
    },
    // [SET_RATING]: (state, rating) => {
    //     state.companies.searchParams.rating = rating;
    //     state.companies.searchParams.page = 1;
    // },
    [SET_CERTIFICATE]: (state, certid) => {
        state.companies.searchParams.certid = certid;
        state.companies.searchParams.page = 1;
    },
    [RESET_SEARCH]: (state, payload) => {
        state.companies.isLoading = false;
        state.companies.error = false;
        state.companies.searchParams = {
            q: '',
            page: 1,
            take: 10,
            category: null,
            region: null,
            // to not send rating to request as rating filter is hidden
            // rating: null,
            certid: null,
        };
        state.companies.data = {};
    },
};

export const getters = {
    [GET_COMPANIES]: state => {
        return state.companies.data;
    },
    [IS_LOADING]: state => {
        return state.companies.isLoading;
    },
    [GET_ERROR]: state => {
        return state.companies.error;
    },
    [GET_SEARCH_PARAMS]: state => {
        return state.companies.searchParams;
    },
    [GET_REGION]: state => {
        return state.companies.searchParams.region ? state.companies.searchParams.region : null;
    },
    [GET_CATEGORY]: state => {
        return state.companies.searchParams.category ? state.companies.searchParams.category : null;
    },
    [GET_PAGE]: state => {
        return state.companies.searchParams.page;
    },
    [GET_FACET_TITLE]: state => {
        if(state.companies.data.content && state.companies.data.content.title && state.companies.data.content.title.rendered){
            return state.companies.data.content.title.rendered;
        }
        return null;
    },
    [GET_FACET_CONTENT]: state => {
        if(state.companies.data.content && state.companies.data.content.content && state.companies.data.content.content.rendered){
            return state.companies.data.content.content.rendered;
        }
        return null;
    },
    [GET_FACET_FULL_CONTENT]: state => {
        if(state.companies.data.content && state.companies.data.content){
            return state.companies.data.content;
        }
        return null;
    },
};



// WEBPACK FOOTER //
// ./src/store/store-models/companies-model.js